import { createMemo, onMount } from "solid-js";
import styles from './st-dorito.module.css';

class DoritoProps {
    tooltip: string = ''
    type: 'danger' | 'info' | 'warning' = 'info'
}

export default function Dorito(props: DoritoProps) {
    const position = createMemo(() => {
        switch (props.type) {
            case 'danger': return 'upper-right';
            case 'warning': return 'lower-right';
            case 'info': return 'upper-left';
            default: return 'upper-left';
        }
    })

    let el!: HTMLElement;
    onMount(() => {
        const parent = el.parentElement;
        if (parent) {
            const position = window.getComputedStyle(parent).position;
            if (position === 'static') {
                parent.style.position = 'relative';
            }
        }
    })

    return <span ref={el} class={styles.dorito} use: tooltip={props.tooltip} data-position={position()} data-type={props.type}></span>
}
Dorito.defaultProps = new DoritoProps();